import {Deserializable} from "../deserializable.model";

export class Offering implements Deserializable  {
  HEADER!:string;
    HEADER_DESCRIPTION!:string;
    STANDARD_MODULE_COVERAGE!:string;
    OFFERING_DECK_NAME!:string;
    OFFERING_DECK_URL!:string;
    DEMO_LINK!:string;
    PREREQ_DOCKET_NAME!:string;
    PREREQ_DOCKET_URL!:string;
    SAMPLE_DECK_NAME!:string;
    SAMPLE_DECK_URL!:string;
    SAMPLE_OFFLINE_NAME!:string;
    SAMPLE_OFFLINE_URL!:string;
    OUTPUT_LINK!:string;

    deserialize(input: any) {
        Object.assign(this, input);
        return this;
      }
}
